export default {
  search: ['请输入您要搜索的用户名', 'Please enter the username'],
  time: ['登录时间', 'Login Time'],
  mode: ['模式', 'Mode'],
  adminMode: ['管理员', 'Admin'],
  staffMode: ['员工', 'Staff'],
  username: ['用户名', 'Username'],
  realname: ['称呼', 'Call'],
  note: ['提示', 'Note'],
  loginSuccess: ['登录成功', 'Login Success'],
  loginError: ['登录失败', 'Login Error'],
  attack: ['攻击密码', 'Attack Password']
};
